import React, { useCallback } from 'react';
import { NimueSelection, NimueModifierTexts } from '../../../types';

interface NimueOptionProps {
  optionKey: 'option1' | 'option2';
  options: NimueSelection;
  currentModifiers: NimueModifierTexts;
  toggleOption: (option: 'option1' | 'option2') => void;
  assets: {
    mod_frame_on: string;
    mod_frame_off: string;
    text_bg: string;
  };
}

const NimueOption = React.memo(({ optionKey, options, currentModifiers, toggleOption, assets }: NimueOptionProps) => {
  const handleToggle = useCallback(() => toggleOption(optionKey), [toggleOption, optionKey]);

  const getOptionText = () => {
    const selection = options?.[optionKey];
    const modifiers = currentModifiers?.[optionKey];
    
    if (selection === 'A') return modifiers?.A;
    if (selection === 'B') return modifiers?.B;
    return modifiers?.null || 'Modifier Inactive';
  };

  return (
    <div className="nimue-mod-column">
      <div
        className="nimue-mod-icon"
        onClick={handleToggle}
        style={{
            backgroundImage: `url('${options?.[optionKey] ? assets.mod_frame_on : assets.mod_frame_off}')`,
        }}
      >
      </div>
      <div 
        className="nimue-mod-text"
        onClick={handleToggle}
        style={{ backgroundImage: `url('${assets.text_bg}')` }}
      >
        {getOptionText()}
      </div>
    </div>
  );
});

export default NimueOption;
